import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";
import { useState } from "react";
import { convertToCurrencyFormat } from "../../../../shared/utility";
import ReceivingSubTable2 from "./ReceivingSubtable2";
import TraceableBarcode from "../../../controls/TraceableBarcode";
import TraceableLotNumber from "../../../controls/TraceableLotNumber";

export default function ReceivingSubTable1(props) {
  const {
    data,
    loadingRows,
    rowDetails,
    fetchSubRowDetails,
    subRowDetails,
    subLoadingRows,
    selectedItems,
    setSelectedItems,
  } = props;

  const [expandedRows, setExpandedRows] = useState(null);

  const onRowExpand = (event) => {
    const rowData = event.data;
    if (!subRowDetails[rowData.unique_id]) {
      fetchSubRowDetails(rowData);
    }
  };

  const allowExpansion = (rowData) => {
    return rowData.pallet_id;
  };

  function rowExpansionTemplate(data) {
    return (
      <ReceivingSubTable2
        data={data}
        loadingRows={subLoadingRows}
        rowDetails={subRowDetails}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
      />
    );
  }

  const bodyProductName = (item) => {
    return (
      <div>
        {item.product_name} <br />{" "}
        <span className="font-bold">PLU: {item.plu}</span>
      </div>
    );
  };

  if (loadingRows[data.unique_id]) {
    return <ProgressSpinner style={{ width: "30px", height: "30px" }} />;
  }

  const detail = rowDetails[data.unique_id];
  if (!detail) return null;

  const barcodeBody = (data) => <TraceableBarcode barcode={data.barcode} />;
  const lotNumberBody = (data) => (
    <TraceableLotNumber lotNumber={data.lot_number} traceType="supplier" />
  );

  const bodySubItemWeight = (item) => {
    return (
      <p>
        {item.total_weight_in_kg} kg <br />
        {item.total_weight_in_lbs} lbs
      </p>
    );
  };

  const bodyItemPieceCount = (item) => {
    return <p>{item.total_pieces} pieces</p>;
  };

  const bodyParentUnitCost = (item) => {
    return <p>{convertToCurrencyFormat(item.unit_cost)}</p>;
  };

  const bodyParentTotalCost = (item) => {
    return <p>{convertToCurrencyFormat(item.total_cost)}</p>;
  };

  const bodyParentLocation = (item) => {
    return (
      <p>
        {item.warehouse_name} <br />
        {item.warehouse_location_name}
      </p>
    );
  };

  const cartonCountBody = (item) => {
    return <p>{item.total_cartons} cartons</p>;
  };

  return (
    <div>
      <DataTable
        value={rowDetails[data.unique_id]}
        expandedRows={expandedRows}
        onRowToggle={(e) => {
          setExpandedRows(e.data);
        }}
        onRowExpand={onRowExpand}
        rowExpansionTemplate={rowExpansionTemplate}
        dataKey="unique_id"
        tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm receiving-sub-items-table-1"
        cellClassName="py-2 bg-gray-100 border-1-bottom-gray px-2 text-sm inv-sub-item"
        selectionMode="checkbox"
        selection={selectedItems}
        onSelectionChange={(e) => setSelectedItems(e.value)}
      >
        <Column
          selectionMode="multiple"
          headerStyle={{ width: "3rem" }}
        ></Column>
        <Column
          header="Product Name"
          body={bodyProductName}
          style={{ width: "17%" }}
        />
        <Column header="Lot Number" body={lotNumberBody} style={{ width: "10%" }} />
        <Column header="Barcode" body={barcodeBody} style={{ width: "24%" }} />
        <Column
          header="Carton Count"
          body={cartonCountBody}
          style={{ width: "8%", textAlign: "right" }}
        />
        <Column
          header="Total Weight"
          body={bodySubItemWeight}
          style={{ width: "10%", textAlign: "right" }}
        />
        <Column
          header="Piece Count"
          body={bodyItemPieceCount}
          style={{ width: "8%", textAlign: "right" }}
        />
        <Column
          header="Unit Cost"
          body={bodyParentUnitCost}
          style={{ width: "7%", textAlign: "right" }}
        />
        <Column
          header="Total Cost"
          body={bodyParentTotalCost}
          style={{ width: "7%", textAlign: "right" }}
        />
        <Column
          body={bodyParentLocation}
          header="Location"
          style={{ width: "10%" }}
        />
        <Column expander={allowExpansion} style={{ width: "6%" }} />
      </DataTable>
    </div>
  );
}
